import React from 'react';

const SignUp = () => {
    return (
        <p>
            Sign my petition
        </p>
    );
};

export default SignUp;
